import { createStore } from 'zustand';
import { devtools } from 'zustand/middleware';

// Enums
import { dtoState } from '../../../../common/enums/dtoState';

// Helpers
import { flattenDTO } from '../common/helpers/flattenDTO';

export const createPredicateStore = (initialState = {}) => {
    return createStore()(
        devtools(
            (set) => ({
                predicates: initialState,
                init: (predicate) => {
                    set((state) => {
                        return {
                            ...state,
                            predicates: predicate ? flattenDTO(ko.toJS(predicate), true) : {}
                        };
                    });
                },
                reset: () => {
                    set((state) => {
                        return {
                            ...state,
                            predicates: initialState
                        };
                    });
                },
                addPredicate: (predicate) => {
                    set((state) => {
                        return {
                            ...state,
                            predicates: {
                                ...state.predicates,
                                ...flattenDTO({ ...predicate })
                            }
                        };
                    });
                },
                updatePredicate: (predicate) => {
                    set((state) => ({
                        ...state,
                        predicates: {
                            ...state.predicates,
                            ...flattenDTO(predicate)
                        }
                    }));
                },
                addPredicatePart: ({ predicatePart, parentUuid }) => {
                    set((state) => {
                        const newPredicatePart = {
                            ...predicatePart,
                            dtoState: dtoState.New
                        };

                        return {
                            ...state,
                            predicates: {
                                ...state.predicates,
                                [predicatePart.uuid]: newPredicatePart,
                                [parentUuid]: {
                                    ...state.predicates[parentUuid],
                                    predicateParts: [
                                        ...(state.predicates[parentUuid]?.predicateParts ?? []),
                                        newPredicatePart.uuid
                                    ]
                                }
                            }
                        };
                    });
                },
                updatePredicatePart: ({ predicatePart }) => {
                    set((state) => {
                        return {
                            ...state,
                            predicates: {
                                ...state.predicates,
                                [predicatePart.uuid]: {
                                    ...predicatePart,
                                    dtoState:
                                        state.predicates[predicatePart.uuid].dtoState === dtoState.New
                                            ? dtoState.New
                                            : dtoState.Updated
                                }
                            }
                        };
                    });
                },
                deletePredicatePart: ({ predicatePart, parentUuid }) => {
                    set((state) => {
                        if (state.predicates[predicatePart.uuid].dtoState === dtoState.New) {
                            const updatedState = {
                                ...state,
                                predicates: {
                                    ...state.predicates,
                                    [parentUuid]: {
                                        ...state.predicates[parentUuid],
                                        predicateParts: (state.predicates[parentUuid]?.predicateParts ?? []).filter(
                                            ({ uuid }) => uuid !== predicatePart.uuid
                                        )
                                    }
                                }
                            };
                            delete updatedState.predicates[predicatePart.uuid];

                            return updatedState;
                        } else {
                            return {
                                ...state,
                                predicates: {
                                    ...state.predicates,
                                    [predicatePart.uuid]: {
                                        ...predicatePart,
                                        dtoState: dtoState.Deleted
                                    }
                                }
                            };
                        }
                    });
                },
                // updatePartOrder: ({ parentUuid, newOrderedPredicatePartIds = [] }) => {
                //     set((state) => {
                //         const predicatePartOrders = newOrderedPredicatePartIds
                //             .map((id) => {
                //                 return state.predicates[id].predicatePartOrder;
                //             })
                //             .sort((a, b) => a - b);
                //         const updatedPredicateParts = newOrderedPredicatePartIds.reduce(
                //             (acc, curr, index) => ({
                //                 ...acc,
                //                 [curr]: {
                //                     ...state.predicates[curr],
                //                     dtoState: [dtoState.Deleted, dtoState.New].includes(state.predicates[curr].dtoState)
                //                         ? state.predicates[curr].dtoState
                //                         : dtoState.Updated,
                //                     predicatePartOrder: predicatePartOrders[index]
                //                 }
                //             }),
                //             {}
                //         );
                //         console.log('updatedPredicateParts', updatedPredicateParts);

                //         return {
                //             ...state,
                //             predicates: {
                //                 ...state.predicates,
                //                 [parentUuid]: {
                //                     ...state.predicates[parentUuid],
                //                     predicateParts: [...newOrderedPredicatePartIds]
                //                 },
                //                 ...updatedPredicateParts
                //             }
                //         };
                //     });
                // },
                updatePartOrder: ({ parentUuid, newOrderedPredicatePartUuids = [] }) => {
                    set((state) => {
                        let orderCount = 0;
                        const updatedPredicateParts = newOrderedPredicatePartUuids.reduce((acc, curr, index) => {
                            if (state.predicates[curr].dtoState === dtoState.Deleted) return acc;
                            orderCount++;
                            return {
                                ...acc,
                                [curr]: {
                                    ...state.predicates[curr],
                                    dtoState: [dtoState.Deleted, dtoState.New].includes(state.predicates[curr].dtoState)
                                        ? state.predicates[curr].dtoState
                                        : dtoState.Updated,
                                    predicatePartOrder: orderCount
                                }
                            };
                        }, {});

                        return {
                            ...state,
                            predicates: {
                                ...state.predicates,
                                [parentUuid]: {
                                    ...state.predicates[parentUuid],
                                    predicateParts: [...newOrderedPredicatePartUuids]
                                },
                                ...updatedPredicateParts
                            }
                        };
                    });
                }
            }),
            {
                name: 'PredicateStore'
            }
        )
    );
};
